import { ServicesContainer } from '@/services';
import { AnalyticsEventType, WebPageDetails } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AdobeBaseEvent } from './adobe-base-event';
import router from '@/router';

export class AdobeOrderConfirmedEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.OrderConfirmed;
  eventType = 'cmg_orderConfirmed';
  constructor(event: string, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    Object.assign(this.web.webPageDetails, this.createCheckoutDetails());
    if(store.state.ui.orderCancellation?.orderConfirmationMethod === 'manual-confirmation') {
      this.web.webInteraction = {
        linkClicks: { value: 1 },
        name: 'LOOKS GOOD',
        type: 'other',
      };
    }
    this.commerce.orderConfirmed = { value: 1 };
    this.commerce.orderReviewTime = store.state.ui.orderCancellation?.orderReviewTime || '0';
    this.commerce.orderConfirmationMethod = store.state.ui.orderCancellation?.orderConfirmationMethod || 'automatic-timeout';
  }

  createCheckoutDetails(): WebPageDetails {
    const siteSection = 'order';
    const pageType = router.currentRoute.name;
    let details = {
      pageType,
      siteSection,
      pageViews: {value: 1},
      subSection1: 'checkout',
      name: `${siteSection}:${pageType}:review-order`,
    } as WebPageDetails;

    return details;
  }
}
